<template>
  <div
    :class="the_class"
    v-if="active"
  >
    <div class="personalisation-overlay" tabindex="0">
      <div class="personalisation-overlay-top">
        <div class="personalisation-overlay-top-title">
          <span class="pre-title">Personalise your item</span>
          <h4 id="personalisationTitle" class="title">{{ productTitle }}</h4>
        </div>
        <div @click="close()" tabindex="0" type="button" class="personalisation-overlay-top-close personalisation__container-logo-close">
          <svg id="SVGDoc" width="7" height="7" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" viewBox="0 0 7 7"><defs></defs><desc>Generated with Avocode.</desc><g><g><title>close_mini [#1522]</title><path d="M4.90002,3.5v0l2.09998,2.10001v0l-1.40002,1.39999v0l-2.09998,-2.10001v0l-2.09998,2.10001v0l-1.40002,-1.39999v0l2.09998,-2.10001v0l-2.09998,-2.10001v0l1.40002,-1.39999v0l2.09998,2.10001v0l2.09998,-2.10001v0l1.40002,1.39999v0z" fill="#f1e6b2" fill-opacity="1"></path></g></g></svg>
        </div>
      </div>
      <div class="personalisation-overlay-bottom">
        <div class="personalisation-overlay-image">
          <img loading="lazy" height="190" width="190" :src="backgroundImage" :alt="productTitle">
        </div>

        <div class="personalisation-overlay-details">
          <BottledByFor
            v-if="bottledByForPersonalisation"
            :variantId="variantId"
            :productId="productId"
            :setActive="setActive"
            :setAdding="setAdding"
            :b2b-cart="b2bCart"
          />
          <BottledByOnly
            v-else-if="bottledByOnlyPersonalisation"
            :variantId="variantId"
            :productId="productId"
            :setActive="setActive"
            :setAdding="setAdding"
            :b2b-cart="b2bCart"
          />
          <form v-else class="product-aside-personalise-form" @submit.prevent>
            <div v-if="isB2B">
              <span>Recipient name: {{ b2bCart.recipientName }}</span>
            </div>

            <div v-if="isB2B && b2bMultiPersonalisation">
              <div v-if="feature.B2B.autofill_personalisation" class="form-input">
                <div @click="toggleB2BDropdown" :class="dropdownCss()">
                  <ul data-test="product-variant-dropdown">
                    <li class="selected">Select option</li>
                    <li class="variant-dropdown" @click="setB2BDropdown('name')">
                      {{ b2bCart.recipientName }}
                    </li>
                    <li v-if="b2bCompany.companyName" class="variant-dropdown" @click="setB2BDropdown('company')">
                      {{ b2bCompany.companyName }}
                    </li>
                    <li class="variant-dropdown" @click="setB2BDropdown('custom')">
                      Custom message
                    </li>
                  </ul>
                </div>
              </div>
              <div v-if="feature.B2B.autofill_personalisation & b2bDropdown.selected !== ''" class="form-input">
                <input
                  class="sensitive"
                  autofocus
                  :disabled="adding"
                  ref="input"
                  id="personalisation-input"
                  placeholder="personalised message"
                  :maxlength="max_message_length"
                  v-model='message'
                  type="text"
                />
                <span :class="charCount > max_message_length ? 'count-over' : 'count'" >{{charCount}}/{{max_message_length}}</span>
              </div>
              <div v-else class="form-input">
                <input
                  class="sensitive"
                  autofocus
                  :disabled="adding"
                  ref="input"
                  id="personalisation-input"
                  placeholder="personalised message"
                  :maxlength="max_message_length"
                  v-model='message'
                  type="text"
                />
                <span :class="charCount > max_message_length ? 'count-over' : 'count'" >{{charCount}}/{{max_message_length}}</span>
              </div>
            </div>

            <div class="form-input" v-if="!isB2B && b2bMultiPersonalisation">
              <input
                class="sensitive"
                autofocus
                :disabled="adding"
                ref="input"
                id="personalisation-input"
                placeholder="personalised message"
                :maxlength="max_message_length"
                v-model='message'
                type="text"
              />
              <span :class="charCount > max_message_length ? 'count-over' : 'count'" >{{charCount}}/{{max_message_length}}</span>
            </div>

            <button
              style="width: 100%"
              :class="buttonAddClass"
              @click="addToCart"
            >Add to cart</button>
          </form>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import globalTheme from "Assets/js/components/globalTheme";
import shopifyCdn from "Assets/js/components/shopifyCdn";
import BottledByFor from "Templates/blocks/personalisationOverlay/bottledByFor.vue";
import { mapGetters } from "vuex";
import rateLimit from "axios-rate-limit";
import axios from "axios";
import { isEmpty } from "lodash-es";
import engravingHelper from "Assets/js/components/helpers/engravingHelper";
import BottledByOnly from "Templates/blocks/personalisationOverlay/bottledByOnly.vue";

export default {
  name: "PersonalisationOverlay",
  props: {
    title: String,
    image: String,
    product_id: String,
    cart_id: String,
  },
  components: {
    BottledByFor,
    BottledByOnly
  },
  data() {
    return {
      active: false,
      adding: false,
      globalTheme: globalTheme,
      bottledByForPersonalisation: false,
      bottledByOnlyPersonalisation: false,
      message: '',
      bottledByInput: '',
      forInput: '',
      max_message_length: 20,
      variantId: '',
      productId: '',
      product: {},
      productTitle: '',
      productImage: '',
      engraving: {},
      b2bCart: {},
      b2bDropdownActive: false,
      b2bDropdown: {
        selected: ''
      },
    }
  },
  computed: {
    ...mapGetters([
      'cartInstance',
      'isB2B',
      'b2bCompany',
      'feature'
    ]),
    the_class(){
      if(this.active){
        return 'personalisation-modal personalisation__container--show'
      }
      return 'personalisation-modal personalisation__container--hide'
    },
    backgroundImage() {
      return shopifyCdn.getImage(this.productImage, 190, 190);
    },
    charCount(){
      return this.message.length;
    },
    buttonAddClass(){
      if(this.adding || this.charCount === 0 || this.charCount > this.max_message_length){
        return 'preview-button--disabled'
      }
      return 'preview-button';
    },
    b2bMultiPersonalisation() {
      return !!this.feature.B2B?.multi_personalisation;
    },
  },
  methods: {
    handleKeyDown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        this.close();
      }
    },
    dropdownCss() {
      const icon = this.b2bDropdownActive ? 'zmdi-chevron-up' : 'zmdi-chevron-down';
      return `variant-dropdown variant-dropdown--${this.b2bDropdownActive ? 'active' : 'inactive'} zmdi ${icon}`;
    },
    toggleB2BDropdown() {
      this.b2bDropdownActive = !this.b2bDropdownActive;
    },
    setB2BDropdown(variant) {
      //this.b2bDropdownActive = false;
      this.b2bDropdown.selected = variant;
      switch(variant){
        case 'name':
          this.message = this.b2bCart.recipientName;
          break;
        case 'company':
          this.message = this.b2bCompany.companyName;
          break;
        case 'custom':
          this.message = '';
          break;
      }
    },
    async fetch() {
      const http = rateLimit(axios.create(), {
        maxRequests: 6,
        perMilliseconds: 1000,
        maxRPS: 6
      });

      let response = '[]';

      const data = JSON.stringify({
        query: `query products{
          products(with_shopify_id: "${this.productId}",
          allow_out_of_stock: true,
          allow_enquire_now: true){
              shopify_title
              shopify_id
              shopify_metafields{
                bottled_by_for
                bottled_by_only
              }
          }
        }`
      });

      const config = {
        method: 'post',
        url: `${window.global_theme_object.site_url}/graphql`,
        headers: {
          'Content-Type': 'application/json'
        },
        data
      };

      await http(config).then((response) => {
        this.product = response.data.data.products[0];
        this.bottledByForPersonalisation = this.product?.shopify_metafields?.bottled_by_for ?? false;
        this.bottledByOnlyPersonalisation = this.product?.shopify_metafields?.bottled_by_only ?? false;
      });
    },
    setActive(state){
      this.active = state;
    },
    setAdding(state){
      this.adding = state;
    },
    addToCart(){
      if(this.charCount > this.max_message_length){
        return;
      }
      this.adding = true;
      if (!isEmpty(this.b2bCart)) {
        // B2B personalisation
        this.cartInstance.updateB2BCartWithPersonalisation(
          this.b2bCart.lineItemId,
          this.b2bCart.lineItemAttributes,
          this.message,
          (responseData) => {
            if (responseData.status === 200) {
              this.active = false;
              this.adding = false;
            }

            window.dispatchEvent(new CustomEvent("cart-changed", {
              detail: {
                cart: this.cartInstance.getCart()
              }
            }));
            // Trigger callback
            if (typeof this.b2bCart.callback === 'function') {
              this.b2bCart.callback(this.message);
            }
          });
      } else if( this.engraving && this.engraving.active && this.engraving.product.availableForSale) {
        // Engraving
        this.cartInstance.addToCartWithEngraving(this.variantId, this.engraving.product.id, this.message, this.productId, (responseData) => {
          if (responseData.status === 200) {
            this.active = false;
            this.adding = false;
            window.dispatchEvent(new CustomEvent('cart-changed', {
              detail: {
                cart: this.cartInstance.getCart()
              }
            }));
            return;
          }
          window.dispatchEvent(new CustomEvent('cart-changed', {
            detail: {
              cart: this.cartInstance.getCart()
            }
          }));
        });
      } else {
        this.cartInstance.addToCartWithPersonalisation( this.variantId, this.message, this.productId, (responseData) => {
          if (responseData.status === 200) {
            this.active = false;
            this.adding = false;
            window.dispatchEvent(new CustomEvent('cart-changed', {
              detail: {
                cart: this.cartInstance.getCart()
              }
            }));
            return;
          }
          window.dispatchEvent(new CustomEvent('cart-changed', {
            detail: {
              cart: this.cartInstance.getCart()
            }
          }));
        });
      }
    },
    close() {
      if (this.adding) {
        return;
      }
      this.active = false;
    },
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyDown);
    function fixEngravingResponse(responseData) {
      return {
        id: responseData.id.edges[0].node.id,
        product_id: responseData.product_id,
        availableForSale: responseData.availableForSale,
        title: responseData.title,
        price: responseData.price.edges[0].node.priceV2
      };
    }

    window.addEventListener('personalisation-toggled', (event) => {
      this.message = '';
      this.productTitle = globalTheme.formatTitle(event.detail.title);
      this.productImage = event.detail.img;
      this.max_message_length = event.detail.limit ?? 20;
      this.variantId = event.detail.variant;
      this.productId = event.detail.productId ?? '';
      this.fetch();
      this.engraving = event.detail.engraving;
      if(event.detail.engraving){
        this.engraving.active = true;
        this.engraving.type = event.detail.engraving;
        this.max = parseInt(event.detail.engraving.limit);
        this.engraving.limit = event.detail.engraving.limit ?? event.detail.limit;
        this.cartInstance.getEngravingProduct(event.detail.engraving.product.product_id, (responseData) => {
          if(responseData){
            this.engraving.product =  fixEngravingResponse(responseData);
            this.engraving.engraving_type = engravingHelper.getEngravingType(responseData.title);
          }
        });
      }
      this.b2bCart = event.detail.b2bCart || {};
      if (!isEmpty(this.b2bCart)) {
        this.message = this.b2bCart.personalisationLabel || "";
      }
      this.adding = false;
      this.active = !this.active;
    });
  },
  updated() {
    if(!this.active) {
      return;
    }
    const top = this.$el.querySelector('.personalisation-overlay-top');
    if (top && !top.classList.contains('personalisation-overlay-top-visible')) {
      top.classList.add('personalisation-overlay-top-visible');
    }
  }
}
</script>
